import httpRequest from '../../common/lib/http-request';

// *************************
// DOCUMENT SERVICES
// *************************

function downloadDocument(documentRef) {
    return httpRequest({
        url: '/Document/download/raw/' + documentRef,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const DocumentService = { downloadDocument }

export default DocumentService;